import * as types from './types'

const initialState = {
	isLoading: false,
	isSuccess: false,
	contracts: null,
}

export const reducer = (state = initialState, action) => {
	const { type, payload } = action
	switch (type) {
		case types.TOGGLE_LOADING:
			return { ...state, isLoading: payload }
		case types.TOGGLE_SUCCESS:
			return { ...state, isSuccess: payload }
		case types.SET_CONTRACTS:
			return { ...state, contracts: payload }
		case types.RESET_CONTRACTS:
			return {
				...state,
				contracts: null,
				isSuccess: false,
			}
		default:
			return state
	}
}
